export default __webpack_public_path__ + "static/media/GOOGLE.221f782d.png";